import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import PersonalDetails from "@/components/developer/PersonalDetails";
import CompanyPreferences from "@/components/developer/CompanyPreferences";
import Summary from "@/components/developer/Summary";
import TechnicalSkills from "@/components/developer/TechnicalSkills";
import WorkExperience from "@/components/developer/WorkExperience";
import Projects from "@/components/developer/Projects";
import Education from "@/components/developer/Education";
import Certifications from "@/components/developer/Certifications";
import ResumeUploadModal from "@/components/developer/ResumeUploadModal";
import { UserProvider } from "@/contexts/UserContext";

const DeveloperDashboard = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      toast({
        title: "Error",
        description: "Failed to sign out. Please try again.",
        variant: "destructive",
      });
    } else {
      toast({
        title: "Success",
        description: "You have been signed out successfully.",
      });
      navigate("/");
    }
  };

  return (
    <UserProvider>
      <div className="min-h-screen bg-gray-50 p-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-3xl font-bold">Edit your profile</h1>
            <div className="space-x-4">
              <Button onClick={() => setIsUploadOpen(true)}>Upload resume</Button>
              <Button 
                variant="destructive" 
                onClick={handleLogout}
              >
                Logout
              </Button>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Left Column */}
            <div className="space-y-6">
              <PersonalDetails />
              <CompanyPreferences />
            </div>

            {/* Right Column */}
            <div className="md:col-span-2 space-y-6">
              <Summary />
              <TechnicalSkills />
              <WorkExperience />
              <Projects />
              <Education />
              <Certifications />
            </div>
          </div>

          <ResumeUploadModal 
            isOpen={isUploadOpen}
            onOpenChange={setIsUploadOpen}
          />
        </div>
      </div>
    </UserProvider>
  );
};

export default DeveloperDashboard;